import React, { useState } from 'react';
import checklistData from './checklist.json';

export default function App() {
  const [completed, setCompleted] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const totalItems = checklistData.sections.reduce(
    (sectionTotal, section) =>
      sectionTotal + section.groups.reduce((groupTotal, group) => groupTotal + group.items.length, 0),
    0
  );

  function handleCheckboxChange(event) {
    const { checked, dataset } = event.target;
    const { id } = dataset;

    setCompleted(current =>
      checked ? [...current, id] : current.filter(itemId => itemId !== id)
    );
  }

  async function handleSubmit() {
    setIsSubmitting(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch('/api/report', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          checklist: {
            completed,
            totalItems
          },
          timestamp: new Date().toISOString()
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to submit report.');
      }

      setSubmitted(true);
      setMessage('Checklist submitted successfully.');
      setTimeout(() => {
        setCompleted([]);
        setSubmitted(false);

        setTimeout(() => {
          try {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          } catch (e) {
            document.documentElement.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        }, 150);
      }, 1500);
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <style>{`
        body {
            font-family: Arial, Helvetica, sans-serif;
            margin: 12px;
            line-height: 1.6;
            background: #f7f7f7;
        }

        h1 {
            text-align: center;
            margin-bottom: 5px;
        }

        h2 {
            text-align: center;
            font-weight: normal;
            color: #555;
            margin-bottom: 40px;
        }

        h3 {
            margin-top: 30px;
            border-bottom: 2px solid #ccc;
            padding-bottom: 5px;
        }

        h4 {
            margin-top: 16px;
            margin-bottom: 8px;
            color: #333;
        }

        .container {
            max-width: 700px;
            margin: 0 auto;
        }

        .section {
            background: #fff;
            padding: 12px;
            margin-bottom: 20px;
            border-radius: 8px;
        }

        label {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px;
            min-height: 44px;
            margin-bottom: 8px;
            border-radius: 8px;
        }

        input[type="checkbox"] {
            width: 20px;
            height: 20px;
            flex-shrink: 0;
        }

        button {
            width: 100%;
            padding: 14px;
            font-size: 16px;
            border-radius: 10px;
            border: 1px solid #ccc;
            background: #fff;
        }

        @media (min-width: 768px) {
            body {
                margin: 40px;
            }
        }
      `}</style>
      <div className="container">
        <h1>Bigger House / Cleaner House - Time to Prove It</h1>
        <h2>If the house looks like a tornado hit it… nobody&apos;s coming over… and nobody’s going anywhere 😏</h2>

        {checklistData.sections.map(section => (
          <React.Fragment key={section.id}>
            <div className="section">
              <h3>{section.label}</h3>

              {section.groups.map(group => (
                <React.Fragment key={group.id}>
                  {group.label ? <h4>{group.label}</h4> : null}
                  {group.items.map(item => (
                    <label key={item.id}>
                      <input
                        type="checkbox"
                        data-id={item.id}
                        checked={completed.includes(item.id)}
                        onChange={handleCheckboxChange}
                      />
                      {item.label}
                    </label>
                  ))}
                </React.Fragment>
              ))}
            </div>

            {section.pageBreakAfter ? <div style={{ pageBreakAfter: 'always' }}>   </div> : null}
          </React.Fragment>
        ))}

        <div style={{ marginBottom: '40px', textAlign: 'center' }}>
          <button type="button" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : submitted ? '✅ Submitted!' : 'Submit'}
          </button>
          {message ? <p>{message}</p> : null}
          {error ? <p>{error}</p> : null}
        </div>
      </div>
    </>
  );
}
